import { getUserInfo } from './util';

const oUserInfo = getUserInfo();

/**
 * 初始状态
 */
export const initialState = {
    loading: false,
    isLogin: !!localStorage.getItem('token') || false,
    iUserId: oUserInfo.iUserId || 0,
    sUserAccount: oUserInfo.sUserAccount || null,
    sUserName: oUserInfo.sUserName || '',
    sPhotoPath: oUserInfo.sPhotoPath || '',
    iSupplierId: oUserInfo.iSupplierId || 0,
    sJobTitle: oUserInfo.sJobTitle || '',
    sCompanyName: oUserInfo.sCompanyName || '',
    isAdmin: oUserInfo.isAdmin || 0,
    isAllCandidate: oUserInfo.isAllCandidate || 0,
    isReport: oUserInfo.isReport || 0,
    sLastLoginDateTime: oUserInfo.sLastLoginDateTime || ''
};
